var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-655 -141)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15,
    height: 15,
    transform: "translate(655 141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.977,298.139h-5.792a.946.946,0,0,0-.94.969l0,5.4H174.2a.964.964,0,0,0-.961.974l-.031,6.578h8.583v-2.8a.321.321,0,0,1,.321-.324h1.934a.318.318,0,0,1,.319.324v2.8h2.578V299.108A.967.967,0,0,0,185.977,298.139Zm-9.941,11.754a.294.294,0,0,1-.3.3h-1a.3.3,0,0,1-.3-.3v-1a.305.305,0,0,1,.3-.305h1a.3.3,0,0,1,.3.305Zm0-2.407a.293.293,0,0,1-.3.3h-1a.3.3,0,0,1-.3-.3V306.5a.3.3,0,0,1,.3-.3h1a.291.291,0,0,1,.3.3Zm2.807,2.407a.3.3,0,0,1-.3.3h-1a.3.3,0,0,1-.3-.3v-1a.3.3,0,0,1,.3-.305h1a.3.3,0,0,1,.3.305Zm0-2.407a.3.3,0,0,1-.3.3h-1a.3.3,0,0,1-.3-.3V306.5a.294.294,0,0,1,.3-.3h1a.3.3,0,0,1,.3.3Zm3.644-.983a.3.3,0,0,1-.3.288h-1a.3.3,0,0,1-.307-.288v-1a.306.306,0,0,1,.307-.305h1a.3.3,0,0,1,.3.305Zm0-2.712a.3.3,0,0,1-.3.3h-1a.3.3,0,0,1-.307-.3v-1a.308.308,0,0,1,.307-.3h1a.306.306,0,0,1,.3.3Zm2.9,2.712a.288.288,0,0,1-.295.288h-1a.29.29,0,0,1-.3-.288v-1a.3.3,0,0,1,.3-.305h1a.3.3,0,0,1,.295.305Zm0-2.712a.294.294,0,0,1-.295.3h-1a.3.3,0,0,1-.3-.3v-1a.3.3,0,0,1,.3-.3h1a.3.3,0,0,1,.295.3Zm-2.9-2.63a.3.3,0,0,1-.3.3h-1a.3.3,0,0,1-.307-.3v-1a.307.307,0,0,1,.307-.3h1a.3.3,0,0,1,.3.3Zm2.9,0a.293.293,0,0,1-.295.3h-1a.3.3,0,0,1-.3-.3v-1a.3.3,0,0,1,.3-.3h1a.3.3,0,0,1,.295.3Z",
    transform: "translate(482.791 -156.139)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEntry);
export default __webpack_public_path__ + "static/media/icon_entry.684e4721f59710887d0436d4f2398d1c.svg";
export { ForwardRef as ReactComponent };